import { render, staticRenderFns } from "./approvalSuccessful.vue?vue&type=template&id=0ce78b58&scoped=true"
import script from "./approvalSuccessful.vue?vue&type=script&lang=js"
export * from "./approvalSuccessful.vue?vue&type=script&lang=js"
import style0 from "./approvalSuccessful.vue?vue&type=style&index=0&id=0ce78b58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce78b58",
  null
  
)

export default component.exports